export default {
  heading: "連繫至我的教城帳戶",
  intro: "多謝登入香港教育城網站。您的帳戶還沒有與任何教城帳戶登記作為登入戶口。",
  completed: "登記帳戶成功！現在您可以使用您的帳戶登入教城網站。",
  submit: "綁定",
  iamsmart: {
    intro: "這是你第一次使用「智方便」登入香港教育城網站，請登入你的教城帳戶以完成綁定。",
  },
 form: {
  label: {
    loginId: "電郵 / 登入名稱",
    password: "密碼",
  }
  },
  error:{    
    login:{
      userNotFound: "您的登入名稱或密碼不正確，請再嘗試。",
    },
    jwt:{
      identifierUsed: "您選用的帳戶已登記到另一個教城戶口。",
      userIdUsed: "您選用的教城戶口已登記到另一個帳戶。",
    }, 
  }
};
